const state = {
  renouvellements : [],
  renouvellement : {}
};

const mutations = {
  SET_RENOUVELLEMENTS(state, renouvellements) {
    state.renouvellements = renouvellements;
  },
  REMOVE_RENOUVELLEMENT(state, renouvellement) {
    const renouvellementIndexToRemove = state.renouvellements.findIndex((renouvellementEL) => {
      if (renouvellementEL === renouvellement) {
        return true;
      }
    });
    state.renouvellements.splice(renouvellementIndexToRemove, 1);
  },
  SET_RENOUVELLEMENT(state, renouvellement) {
    state.renouvellement = renouvellement;
  }
};

const actions = {
  saveRenouvellements({ commit }, renouvellements) {
    commit("SET_RENOUVELLEMENTS", renouvellements);
  },
  removeRenouvellement({ commit }, renouvellement) {
    commit("REMOVE_RENOUVELLEMENT", renouvellement);
  },
  saveRenouvellement({ commit }, renouvellement) {
    commit("SET_RENOUVELLEMENT", renouvellement);
  }
};

const getters = {
  renouvellements(state) {
    return state.renouvellements;
  },
  isRenouvellements(state) {
    return state.renouvellements.length > 0;
  },
  isRenouvellementsSubstantiels(state) {
    const renouvellementIndex = state.renouvellements.length > 0 ? state.renouvellements.findIndex(renouvellement => renouvellement.type == "S") : -1;

    return renouvellementIndex === -1 ? false : true;
  },
  isRenouvellementsNotables(state) {
    const renouvellementIndex = state.renouvellements.length > 0 ? state.renouvellements.findIndex(renouvellement => renouvellement.type == "N") : -1;

    return renouvellementIndex === -1 ? false : true;
  },
  renouvellement(state) {
    return state.renouvellement;
  },
  isSubstantielRenouvellementType() {
    return state.renouvellement.type ? state.renouvellement.type === 'S' : false;
  },
  isNotableRenouvellementType() {
    return state.renouvellement.type ? state.renouvellement.type === 'N' : false;
  },

};

export default {
  state,
  mutations,
  actions,
  getters
};
